import { render, staticRenderFns } from "./PrfEnterChamberQR.vue?vue&type=template&id=0a9920a8"
import script from "./PrfEnterChamberQR.vue?vue&type=script&lang=js"
export * from "./PrfEnterChamberQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports